import React, { useState } from "react";
import { Box, Button, Typography, Stack } from "@mui/material";
import { defaultStyle } from "components/Modals";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

interface LoadMeteringPointsModalType {
  contractType: string;
  title: string;
  buttonTitle: string;
  type?: string;
  action: (fetchAll?: boolean, legalConsent?: boolean) => void;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  fetchAll?: boolean;
}

const LegalConsentModal = ({
  contractType,
  title,
  buttonTitle,
  type,
  action,
  setModal,
  fetchAll,
}: LoadMeteringPointsModalType) => {
  const [checked, setChecked] = useState(contractType === "EXTERNAL");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  return (
    <Box sx={defaultStyle}>
      <Typography variant="h5" component="h5" sx={{ mb: "1rem" }}>
        {title}
      </Typography>
      {(contractType === "TOTAL" || contractType === "FIXED") && (
        <Box sx={{ mb: 2 }}>
          <Typography component="p" sx={{ mb: 1 }}>
            <strong>This client has a contract with NPM.</strong>
          </Typography>
          <Typography component="p">
            No legal consent or authorization is required.
          </Typography>
        </Box>
      )}
      {contractType === "EXTERNAL" && (
        <Box sx={{ mb: 2 }}>
          <Typography component="p" sx={{ mb: 1 }}>
            <strong>This client has an external contract with NPM.</strong>
          </Typography>
          <Typography component="p">
            Legal consent or authorization may be required.
          </Typography>
        </Box>
      )}
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={handleChange} />}
        label={"Force legal consent"}
      />
      {(contractType === "TOTAL" || contractType === "FIXED") && (
        <Typography component="p" fontSize={14}>
          Check this box if you still want to load data with a legal consent.
        </Typography>
      )}
      <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
        <Button
          variant="contained"
          onClick={() => {
            if (type === "measurementData") {
              action(fetchAll, checked);
            } else {
              action(checked);
            }
            setModal(null);
          }}
        >
          {buttonTitle}
        </Button>
        <Button onClick={() => setModal(null)}>Cancel</Button>
      </Stack>
    </Box>
  );
};

export default LegalConsentModal;
